/**
 * MiniMiser.WebApi
 * A web API for client access to patient records.   Build date: 2/19/2019 6:49:21 PM
 *
 * OpenAPI spec version: v1.0.02.19
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { ClientInsEditRequestModel } from './clientInsuranceEditRequestModel';
import { PatientInsuranceCardModel } from './patientInsuranceCardModel';


export interface PatientInsuranceModel {
  id?: number;
  insuranceProvider?: string;
  insuranceProviderID?: number;
  insurancePayerTypeID?;
  isPrimary?: boolean;
  memberID?: string;
  patientID?: number;
  policyNumber?: string;
  policyHolderFirstName?: string;
  policyHolderLastName?: string;
  policyHolderDoB?: Date;
  notes?: string;
  authorizationEndDate?: Date;
  startDate?: Date;
  expirationDate?: Date;
  insuranceCards?: Array<PatientInsuranceCardModel>;
  active?: boolean;
  hasAuthorization?: boolean;
  insuranceCardNotRequired?: boolean;
  cancelReason?: string;
  request?: InsuranceRequestModel;
  requireGoodFaithEstimate?: boolean;
  pcnxNumber?: string;
}

export interface InsuranceRequestModel {
  id: number;
  inquiryID: number;
  requestType: string;
  approvedDate: Date;
  deniedDate: Date;
  message: string;
  showMessage:boolean;
  approved: boolean;
  declineReason: string;
  declineReasonViewed: boolean;
}
